import { safeJsonParse } from 'functions/safeJsonParse';
import authenticationConstants from 'components/Authentication/constants';
import {
  SET_NOT_SURE_ANSWERED_QUESTIONS,
} from './intake.actionTypes';
import { NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY } from './intake.constants';
import { prepareNotSureAnsweredQuestions } from './intake.helpers';

const { LOGOUT } = authenticationConstants;

const getInitialState = () => ({
  notSureAnsweredQuestions: prepareNotSureAnsweredQuestions(
    safeJsonParse(localStorage.getItem(NOT_SURE_ANSWERED_QUESTIONS_STORAGE_KEY)) ?? {},
  ),
});

// eslint-disable-next-line default-param-last
export function intakeReducer(state = getInitialState(), action) {
  const { type, payload } = action;
  switch (type) {
    case SET_NOT_SURE_ANSWERED_QUESTIONS:
      return { ...state, notSureAnsweredQuestions: payload };
    case LOGOUT:
      return getInitialState();
    default:
      return state;
  }
}
